export const GET_ENQUIRIES = "GET_ENQUIRIES";
export const GET_ENQUIRIES_LOADING = "GET_ENQUIRIES_LOADING";
